import { call, cancelled, put, takeLatest, select, all } from 'redux-saga/effects';
import {RoutingInjectionTypes, RoutingInjectionActions} from './routing-injection.redux';
import { getMissions, getAgents, getTouchPoints, postRouting, deleteMission, getTradePrograms, getInvolvements } from './routing-injection.api';
import {globalFiltersRoutingUrlParamsSelector} from '../../modules/root/global-filters/global-filters.selectors';
import {selectedAgentUsernameSelector, localFiltersUrlParamsSelector} from './routing-injection.selectors';
import { dateSelector, selectedAgentSelector, selectedTouchPointsSelector, selectedTasksSelector } from './routing-injection.selectors';

function* getDataRequest() {
    try {
        const globalFilters = yield select(globalFiltersRoutingUrlParamsSelector);
        const localFilters = yield select(localFiltersUrlParamsSelector);
        const date = yield select(dateSelector);
        const [data, dayData, agents, tradePrograms, involvements] = yield all([
            call(getMissions, `${globalFilters}`),
            date ? call(getMissions, `${globalFilters}&date=${encodeURIComponent(date)}`) : null,
            call(getAgents, `${localFilters}`),
            call(getTradePrograms),
            call(getInvolvements)
            //call(getTouchPoints, `${globalFilters}`)
        ]);
        yield put(RoutingInjectionActions.getDataSuccess({ by_date: {}, touchpoints: {}, ...data.data, by_staff: dayData && dayData.data ? dayData.data.by_staff : {} }, agents.data, tradePrograms.data.programs, involvements.data));
    } catch (e) {
        yield put(RoutingInjectionActions.getDataError(e));
    } finally {
        if (yield cancelled()) {
            yield put(RoutingInjectionActions.getDataError(null));
        }
    }
}

function* selectAgent({ id, region, district, territory }) {
    const date = yield select(dateSelector);
    try {
        let filters = `region=${region}`;
        if (district)
            filters += `&district=${district}`;
        if (territory)
            filters += `&territory=${territory}`;

        const agent = yield select(selectedAgentUsernameSelector);

        const [response1, response2] = yield all([
            call(getTouchPoints, filters),
            call(getMissions, `date=${encodeURIComponent(date)}&agent=${encodeURIComponent(agent)}`),
        ]);
        const currentAgent = yield select(selectedAgentSelector);
        const currentDate = yield select(dateSelector);
        if (currentAgent === id && currentDate === date)
            yield put(RoutingInjectionActions.getTouchPointsSuccess(response1.data, response2.data));
        else
            yield put(RoutingInjectionActions.getTouchPointsError(null));
    } catch (e) {
        const currentAgent = yield select(selectedAgentSelector);
        const currentDate = yield select(dateSelector);
        yield put(RoutingInjectionActions.getTouchPointsError(currentAgent === id && currentDate === date ? e : null));
    } finally {
        if (yield cancelled()) {
            yield put(RoutingInjectionActions.getTouchPointsError(null));
        }
    }
}

function* addMission() {
    try {
        const date = yield select(dateSelector);
        const agent = yield select(selectedAgentSelector);
        const touchpoints = yield select(selectedTouchPointsSelector);
        const tasks = yield select(selectedTasksSelector);
        const response = yield call(postRouting, { date, agent, touchpoints, tasks });
        yield put(RoutingInjectionActions.addMissionSuccess(response.data));
        yield put(RoutingInjectionActions.getDataRequest());
    } catch (e) {
        yield put(RoutingInjectionActions.addMissionError(e));
    } finally {
        if (yield cancelled()) {
            yield put(RoutingInjectionActions.addMissionError(null));
        }
    }
}

function* deleteMissionRequest({ id }) {
    try {
        yield call(deleteMission, id);
        yield put(RoutingInjectionActions.deleteMissionSuccess());
        yield put(RoutingInjectionActions.getDataRequest());
    } catch (e) {
        yield put(RoutingInjectionActions.deleteMissionError(e));
    } finally {
        if (yield cancelled()) {
            yield put(RoutingInjectionActions.deleteMissionError(null));
        }
    }
}

function* actionFilter() {
    yield put(RoutingInjectionActions.getDataRequest());
}

export default function* routingInjectionSaga() {
    yield takeLatest(RoutingInjectionTypes.GET_DATA_REQUEST, getDataRequest);
    yield takeLatest(RoutingInjectionTypes.SELECT_AGENT, selectAgent);
    yield takeLatest(RoutingInjectionTypes.ADD_MISSION_REQUEST, addMission);
    yield takeLatest(RoutingInjectionTypes.DELETE_MISSION_REQUEST, deleteMissionRequest);
    yield takeLatest(RoutingInjectionTypes.ACTION_FILTER, actionFilter);

}
